import { connect } from 'react-redux';

import { offerTypeFromJsonQuery, dealTypeFromJsonQuery, FDealType, FOfferType } from '../../../../utils/category';
import { IAppState } from '../../../state/app_state';

import { isNpsEnabled } from '../../../../utils/experiments/NpsWidget';

import { TARGET_OFFER_TYPE } from './constants';

import { NpsWidget, INpsWidgetProps } from './NpsWidget';

const getHref = (dealType: FDealType, offerType: FOfferType): string | undefined => {
  if (!(offerType & TARGET_OFFER_TYPE)) {
    return undefined;
  }

  if (dealType & FDealType.RentLongterm) {
    return 'http://sgiz.mobi/s3/fa3b61cd4f75';
  }

  if (dealType & FDealType.Sale) {
    return 'http://sgiz.mobi/s3/778bb2460e36';
  }

  return undefined;
};

export const mapStateToProps = (state: IAppState) => {
  const { isAuthenticated } = state.user;
  const { jsonQuery } = state.results;

  return {
    href: getHref(dealTypeFromJsonQuery(jsonQuery), offerTypeFromJsonQuery(jsonQuery)),
    isAuthenticated,
    isEnabled: isNpsEnabled(state.experiments),
  };
};

export const NpsWidgetContainer = connect<INpsWidgetProps>(mapStateToProps)(NpsWidget);
